import { TipoAsignacion } from './tipo-asignacion';
import { ListaItem } from './lista-item';
import { DireccionIp } from './direccion-ip';
import { Usuario } from './usuario';
import { Compania } from './compania';

export class Asignacion {
  idAsignacion: number;
  tipoAsignacion: TipoAsignacion;
  nombreURL: ListaItem = new ListaItem();
  nombreServidor: ListaItem = new ListaItem();
  servicioITNegocio: ListaItem = new ListaItem();
  plataforma: ListaItem = new ListaItem();
  funcion: ListaItem = new ListaItem();
  observaciones: string;
  direccionIp: DireccionIp;
  fechaCreacion: string;
  usuarioCrea: string;
  usuarioInactiva: string;
  configuracionDNS: string;
  indicadorDns: boolean;
  compania: Compania;
  indicadorHabilitado: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/asignacion.ts